import { WalletDashboard } from '@/components/wallet/WalletDashboard';

export default function WalletPage() {
  return <WalletDashboard />;
}
